import React from "react";
import { Route, Routes } from "react-router-dom";
import { AbandonedPage, ConnectionSteps, ErrorPage, GenericPage, InstaEducation, LandingPage, SuccessPage } from "../Pages";
import {
  ROUTE_SUCCESS_PAGE,
  ROUTE_LANDING_PAGE,
  ROUTE_ABANDONED_PAGE,
  ROUTE_ERROR_PAGE,
  ROUTE_GENERIC_PAGE,
  ROUTE_INSTA_EDUCATION_PAGE,
  ROUTE_INVITE_EXPIRED,
  ROUTE_CONNECTION_STEPS,
} from "./RouteMapping";
import InviteExpiredPage from "../Pages/InviteExpiredPage/InviteExpiredPage";

function Router() {
  return (
    <Routes>
      <Route path={ROUTE_LANDING_PAGE} element={<LandingPage />}></Route>
      <Route path={ROUTE_SUCCESS_PAGE} element={<SuccessPage />}></Route>
      <Route path={ROUTE_ABANDONED_PAGE} element={<AbandonedPage />}></Route>
      <Route path={ROUTE_ERROR_PAGE} element={<ErrorPage />}></Route>
      <Route path={ROUTE_GENERIC_PAGE} element={<GenericPage />}></Route>
      <Route path={ROUTE_INVITE_EXPIRED} element={<InviteExpiredPage />}></Route>
      <Route path={ROUTE_INSTA_EDUCATION_PAGE} element={<InstaEducation />}></Route>
      <Route path={ROUTE_CONNECTION_STEPS} element={<ConnectionSteps />}></Route>
      <Route path="*" element={<LandingPage />}></Route>
    </Routes>
  );
}

export default Router;
